import { on } from 'delegated-events';
import Cookies from 'js-cookie';
import type { PaqWindow } from '../../../../types/window';

const cookieName = 'matomo_consent';
const consentCookie = Cookies.get(cookieName);

let matomoLoaded = false;

const load = () => {
  if (!matomoLoaded) {
    const { matomoBaseUrl, matomoSiteId = '1' } = document.body.dataset;

    if (matomoBaseUrl) {
      // eslint-disable-next-line no-underscore-dangle
      (<PaqWindow> window)._paq = [
        ['disableCookies'],
        ['HeatmapSessionRecording::disable'],
        ['trackPageView'],
        ['enableLinkTracking'],
        ['setTrackerUrl', `${matomoBaseUrl}matomo.php`],
        ['setSiteId', matomoSiteId],
      ];

      const $matomo = document.createElement('script');
      $matomo.src = `${matomoBaseUrl}matomo.js`;

      document.body.appendChild($matomo);
    }

    matomoLoaded = true;
  }
};

on('click', '[data-matomo-consent]', (event) => {
  event.preventDefault();

  Cookies.set(cookieName, Date.now().toString(), {
    expires: 365,
    sameSite: 'strict',
  });

  const $banner = event.currentTarget.closest<HTMLElement>('.matomo-banner');
  $banner?.toggleAttribute('hidden', true);

  load();
});

on('click', '[data-matomo-decline]', (event) => {
  event.preventDefault();

  Cookies.set(cookieName, '0', {
    expires: 365,
    sameSite: 'strict',
  });

  const $banner = event.currentTarget.closest<HTMLElement>('.matomo-banner');
  $banner?.toggleAttribute('hidden', true);
});

if (consentCookie && consentCookie !== '0') {
  load();
}
